import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Select from "material-ui/Select";
import DialogModal from "../../common/DialogModal";
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormLabel } from "material-ui/Form";

import Button from "../../Parts/Button";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: 0,
    margin: 0,
    minWidth: "600px",
  },

  innerContainer: {
    padding: "20px 25px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  container: {
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    textAlign: "left",
  },

  formControl: {
    width: "100%",
    marginTop: "22px",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    margin: "40px 0px 30px 0px",
  },

  selectPaper: {
    maxHeight: "unset",
  },
});

class OrderContractFilterDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order_contact_id: 0, // 初期値を設定
    };
  }

  componentDidMount() {
    this.setState({
      order_contact_id: this.props.orderContactId,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.orderContactId && prevProps.orderContactId !== this.props.orderContactId) {
      this.setState({
        order_contact_id: this.props.orderContactId,
      });
    }
  }

  handleChange = (property) => (e) => {
    this.setState({
      [property]: e.target.value,
    });
  };

  handleSave = () => {
    this.props.save(this.state.order_contact_id);
    this.props.toggleDialog();
  };

  render() {
    const { classes, toggleDialog, isOpen } = this.props;

    return (
      <DialogModal
        title="条件で絞り込む"
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div className={classes.innerContainer}>
          <div className={classes.container}>
            <FormControl className={classes.formControl}>
              <FormLabel style={{ color: "#71737B" }}>注文担当者</FormLabel>
              <Select
                value={this.state.order_contact_id}
                onChange={this.handleChange("order_contact_id")}
                disableUnderline={true}
                MenuProps={{
                  classes: {
                    paper: classes.selectPaper,
                  },
                }}
              >
                <MenuItem key={0} value={0}>
                  すべての注文担当者
                </MenuItem>
                {this.props.orderContacts.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className={classes.buttonContainer}>
              <Button
                handleClickButton={this.props.toggleDialog}
                size="large"
                type="ghost"
                text="キャンセル"
                style={{ background: "transparant" }}
              ></Button>
              <Button
                handleClickButton={this.handleSave}
                size="large"
                loading={this.props.isSaving}
                text="検索"
              ></Button>
            </div>
          </div>
        </div>
      </DialogModal>
    );
  }
}

OrderContractFilterDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  orderContactId: PropTypes.number,
  orderContacts: PropTypes.array,
  save: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};

OrderContractFilterDialog.defaultProps = {};

export default withStyles(styles)(OrderContractFilterDialog);



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/dialogs/OrderContractFilterDialog.jsx